import moment from "moment"
import "moment/min/locales"
import * as dateFnsLocales from "date-fns/locale"
import type { Locale } from "date-fns"
import { registerLocale, setDefaultLocale } from "react-datepicker"

const LangugeShortForms: Record<string, string> = {
  "fr-CA": "fr",
  "pt-PT": "pt",
  no: "nb",
  "zh-TW": "zh-tw",
  zh: "zh-cn",
  "es-MX": "es"
}
const LanguageShortFormsForDateFNS: Record<string, string> = {
  "zh-cn": "zh-CN",
  "zh-tw": "zh-TW",
  "en-gb": "en-GB"
}
const dateFnsLocaleModules: Record<string, Locale> = {
  ar: dateFnsLocales.ar,
  bg: dateFnsLocales.bg,
  cs: dateFnsLocales.cs,
  da: dateFnsLocales.da,
  de: dateFnsLocales.de,
  el: dateFnsLocales.el,
  "en-GB": dateFnsLocales.enGB,
  es: dateFnsLocales.es,
  et: dateFnsLocales.et,
  fi: dateFnsLocales.fi,
  fr: dateFnsLocales.fr,
  he: dateFnsLocales.he,
  hu: dateFnsLocales.hu,
  it: dateFnsLocales.it,
  ja: dateFnsLocales.ja,
  ko: dateFnsLocales.ko,
  lt: dateFnsLocales.lt,
  nb: dateFnsLocales.nb,
  nl: dateFnsLocales.nl,
  pl: dateFnsLocales.pl,
  pt: dateFnsLocales.pt,
  "pt-BR": dateFnsLocales.ptBR,
  ro: dateFnsLocales.ro,
  ru: dateFnsLocales.ru,
  sk: dateFnsLocales.sk,
  sl: dateFnsLocales.sl,
  sv: dateFnsLocales.sv,
  th: dateFnsLocales.th,
  tr: dateFnsLocales.tr,
  vi: dateFnsLocales.vi,
  "zh-CN": dateFnsLocales.zhCN,
  "zh-TW": dateFnsLocales.zhTW
}

export const setMomentLocale = async (selectedLanguage: string | null) => {
  let lang = selectedLanguage
  //set userPreferred Language in intial Pageload
  if (selectedLanguage === "en") {
    moment.locale(selectedLanguage)
  } else if (selectedLanguage) {
    lang = LangugeShortForms[selectedLanguage]
      ? LangugeShortForms[selectedLanguage]
      : selectedLanguage
    const adjustedLang = LanguageShortFormsForDateFNS[lang] || lang
    const selectedDateLocale = dateFnsLocaleModules[adjustedLang]
    if (selectedDateLocale) {
      registerLocale(`${lang}`, selectedDateLocale)
    }
  }
  setDefaultLocale(`${lang}`)
  moment.locale(lang ?? undefined)
}

export const getMoment = () => moment
